import { construct, map } from 'ramda';
import { s_r_e as lang } from '~/lang/ru';

export class Defect {
	constructor(data) {
		this.id = data.ID;
		this.name = data.NAME;
		this.description = data.DESCRIPTION;
	}
}

const createDefect = construct(Defect);

export const Conclusion = {
	name: 'Conclusion',
	props: {
		initialDefects: {
			type: Array,
			default: () => [],
		},
	},
	data: (vm) => ({
		defects: map(createDefect, vm.initialDefects),
	}),
	methods: {
		makeConclusion: async function() {
			const { ConclusionModal } = await import('./ConclusionModal');
			const form = new Vue(ConclusionModal);

			form.defects = this.defects;
			form.$mount();
			document.body.appendChild(form.$el);
			form.$refs.modal.show();
		},
	},
	render() {
		return (
			<div>
				<h3 class="font-weight-bold mb-4">{ lang('DIAGNOSTICS') }</h3>
				<button class="block request-info-link" onClick={ this.makeConclusion } type="button">
					{ lang('DIAGNOSE') }
				</button>
			</div>
		)
	},
}
